import React from "react";
import {_url, _baseUrl} from "../helpers/makeUrl";
// import { NavLink } from 'react-router-dom'
import { Link as RouterLink } from 'react-router-dom'

// export function Link(props) {
//     const {to, ...otherProps} = props;
//     return <RouterLink to={_url(to)} {...otherProps}>{props.children}</RouterLink>
// }

export const Link = React.forwardRef((props, ref) => {
    const { to, ...otherProps } = props
    return <RouterLink to={ _url(to) } { ...otherProps }>{props.children}</RouterLink>
})
